import { supportedChains } from "../../shared/constants/chains/supported.js";
import { http } from "viem";
import { createConfig } from "wagmi";
import { coinbaseWallet, injected } from "wagmi/connectors";
/** Default connectors: injected (MetaMask, Rabby, Brave, etc.) + Coinbase Wallet. */
const DEFAULT_CONNECTORS = [injected(), coinbaseWallet({ appName: "B3" })];
/**
 * Creates a generic wagmi config with sensible defaults.
 * No ecosystem wallet, no B3-specific concerns.
 */
export function createWalletConfig(options = {}) {
    const { chains = supportedChains, connectors = DEFAULT_CONNECTORS, rpcUrls } = options;
    if (chains.length === 0) {
        throw new Error("createWalletConfig: at least one chain must be provided");
    }
    return createConfig({
        chains: [chains[0], ...chains.slice(1)],
        transports: Object.fromEntries(chains.map(chain => [chain.id, http(rpcUrls?.[chain.id])])),
        connectors,
    });
}
